(function () {
  if (window.onePillowCartDeliveryLoaded) return;
  window.onePillowCartDeliveryLoaded = true;

  var weekdayCutoffHour = 22;
  var sundayCutoffHour = 21;
  var countdownWindow = 60 * 60 * 1000;
  var observerTimer = null;
  var shippingText = (window.OnePillowI18n && window.OnePillowI18n.shipping) || {};

  function format(template, values) {
    return Object.keys(values).reduce(function (result, key) {
      return result
        .replace('{{ ' + key + ' }}', values[key])
        .replace('__' + key.toUpperCase() + '__', values[key]);
    }, template || '');
  }

  function dateWithHour(baseDate, targetHour, dayOffset) {
    var date = new Date(baseDate);
    date.setDate(date.getDate() + (dayOffset || 0));
    date.setHours(targetHour, 0, 0, 0);
    return date;
  }

  function deliveryLabelForOffset(now, offset) {
    if (offset === 1) return shippingText.tomorrow || '';
    var deliveryDate = new Date(now);
    deliveryDate.setDate(deliveryDate.getDate() + offset);
    return (shippingText.weekdays || [])[deliveryDate.getDay()] || '';
  }

  function getShippingData() {
    var now = new Date();
    var day = now.getDay();
    var hour = now.getHours();

    if (day >= 1 && day <= 4) {
      if (hour < weekdayCutoffHour) {
        return {
          message: format(shippingText.beforeCutoff, { day: deliveryLabelForOffset(now, 1) }),
          countdownLabel: deliveryLabelForOffset(now, 1),
          cutoffTime: dateWithHour(now, weekdayCutoffHour)
        };
      }
      return {
        message: format(shippingText.orderTomorrow, { day: deliveryLabelForOffset(now, 2) }),
        countdownLabel: deliveryLabelForOffset(now, 2),
        cutoffTime: dateWithHour(now, weekdayCutoffHour, 1)
      };
    }

    if (day === 5) {
      if (hour < weekdayCutoffHour) {
        return {
          message: format(shippingText.beforeCutoff, { day: shippingText.tomorrow || '' }),
          countdownLabel: shippingText.tomorrow || '',
          cutoffTime: dateWithHour(now, weekdayCutoffHour)
        };
      }
      return {
        message: format(shippingText.orderedNow, { day: (shippingText.weekdays || [])[1] || '' }),
        countdownLabel: (shippingText.weekdays || [])[1] || '',
        cutoffTime: dateWithHour(now, sundayCutoffHour, 2)
      };
    }

    if (day === 6) {
      return {
        message: format(shippingText.orderedNow, { day: (shippingText.weekdays || [])[1] || '' }),
        countdownLabel: (shippingText.weekdays || [])[1] || '',
        cutoffTime: dateWithHour(now, sundayCutoffHour, 1)
      };
    }

    if (now < dateWithHour(now, sundayCutoffHour)) {
      return {
        message: shippingText.sundayBefore || '',
        countdownLabel: (shippingText.weekdays || [])[1] || '',
        cutoffTime: dateWithHour(now, sundayCutoffHour)
      };
    }

    return {
      message: shippingText.mondayBefore || '',
      countdownLabel: (shippingText.weekdays || [])[2] || '',
      cutoffTime: dateWithHour(now, weekdayCutoffHour, 1)
    };
  }

  function updateCartDelivery() {
    if (document.documentElement.getAttribute('data-op-country') !== 'NL') {
      document.querySelectorAll('[data-op-cart-shipping-info]').forEach(function (element) {
        element.textContent = element.getAttribute('data-op-cart-shipping-neutral') || '';
      });
      document.querySelectorAll('[data-op-cart-shipping-countdown]').forEach(function (element) {
        element.textContent = '';
      });
      return;
    }
    var data = getShippingData();
    var now = new Date();
    var diffMs = data.cutoffTime - now;
    var showCountdown = diffMs > 0 && diffMs <= countdownWindow;

    document.querySelectorAll('[data-op-cart-shipping-info]').forEach(function (element) {
      element.textContent = data.message;
    });

    document.querySelectorAll('[data-op-cart-shipping-countdown]').forEach(function (element) {
      if (!showCountdown) {
        element.textContent = '';
        return;
      }

      var diffSeconds = Math.floor(diffMs / 1000);
      var minutes = Math.floor(diffSeconds / 60);
      var seconds = (diffSeconds % 60).toString().padStart(2, '0');
      var time = '<strong>' + minutes + 'm ' + seconds + 's</strong>';
      element.innerHTML = format(shippingText.countdown, { time: time, day: data.countdownLabel });
    });
  }

  updateCartDelivery();
  document.addEventListener('DOMContentLoaded', updateCartDelivery);
  document.addEventListener('cart:updated', updateCartDelivery);
  window.setInterval(updateCartDelivery, 1000);

  new MutationObserver(function () {
    window.clearTimeout(observerTimer);
    observerTimer = window.setTimeout(updateCartDelivery, 60);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
